module.exports = __webpack_public_path__ + "static/img/ai_training.da52a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/word_quiz/ai_training.png
// module id = pVRs
// module chunks = 1